import { useState } from "react";
import SectionHead from "./SectionHead";
import { QUOTES } from "../../../mocks/chigua";

const badgeCls: Record<string, string> = {
  高赞: "bg-primary-100 text-primary-800",
  金句: "bg-accent-100 text-accent-800",
  本周: "bg-secondary-100 text-secondary-800",
  暖评: "bg-background-100 text-foreground-600",
};

export default function QuoteWall() {
  const [copied, setCopied] = useState(0);

  return (
    <section id="quote" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <SectionHead
          no="05"
          kicker="Shorts · 一句话槽点"
          title="抓奸实录槽点墙"
          sub="评论区被刷得最狠的一行字都在这儿。短、准、狠，适合转发收藏当回怼素材——别问出处，问就是围观群众集体智慧。"
          right="换一批槽点"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {QUOTES.map((q) => (
            <div
              key={q.id}
              className="relative flex flex-col justify-between rounded-lg border border-background-200/80 bg-background-100 p-4 min-h-[120px]"
            >
              <div>
                <span className={"text-[10px] px-1.5 py-0.5 rounded-sm " + (badgeCls[q.tag] || "bg-background-100 text-foreground-600")}>
                  {q.tag}
                </span>
                <p className="mt-3 font-heading text-base font-semibold leading-relaxed text-foreground-900">「{q.text}」</p>
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-[11px] text-foreground-400">#槽点速记</span>
                <button
                  onClick={() => {
                    setCopied(q.id);
                    setTimeout(() => setCopied(0), 1400);
                  }}
                  className="inline-flex items-center gap-1 rounded-md bg-background-50 px-2.5 py-1.5 text-xs text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  <i className={copied === q.id ? "ri-check-line text-primary-600" : "ri-file-copy-line"} />
                  {copied === q.id ? "已复制" : "复制"}
                </button>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-5 text-xs text-foreground-500 inline-flex items-center gap-2">
          <i className="ri-information-line" /> 演示版为静态示例，正式版点击即写评论、一键甩槽点。
        </p>
      </div>
    </section>
  );
}